import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import GettingStarted from '@segment/templates/GettingStarted'

import LayoutBase from '@segment/next-shared/layout'

import Companies from './components/LogoCarousel'
import FeatureBoxGroup from './components/FeatureBoxGroup'
import PipelineHeader from './components/PipelineHeader'
import PipelineSection from './components/PipelineSection'
import Performance from './components/Performance'
import Testimonial from './components/Testimonial'
import Hero from './components/Hero'

import ogImagePng from './assets/OgSegmentIndustryMobile.png'

const IndustryMobileView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="Data Analytics for Mobile Marketing | Twilio Segment"
        pageDescription="Learn why fast-growing mobile apps choose Twilio Segment"
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Main>
          <Hero />
          <Companies />
          <FeatureBoxGroup />
          <PipelineHeader />
          <PipelineSection />
          <Performance />
          <Testimonial />
          <GettingStarted />
        </Main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

export default IndustryMobileView

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`
